import React, { useContext, useState } from "react";
import { AuthContext } from "../../../context/auth/ApiContext";
import { ThemeContext } from "../../../context/theme/ThemeContext";
import { DashBar, EventInfo, StudentSideMenu } from "../../../layout/Dashboard";
import Style from "./calendar.module.scss";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Add, CalendarMonth, Close, Delete, Home, Logout, NotificationsNone, VideoCall, WorkHistory } from "@mui/icons-material";
import ModalLayout from "../../../components/Modal/Modal";

import { authGetRequest, authPostRequest } from "../../../api/laravel/public/api";
import { errorMessage, successMessage } from "../../../utils/notification";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import moment from "moment";
import { ProfileUpdateNotification } from "../../../layout/Notifications";
import { _retrieveData } from "../../../utils/local-storage";
import { Company, Footer, MenuBar } from "../../../layout/welcome";
import { HeaderText, TextInput } from "../../../components";
import { settingContext } from "../../../context/Setting/Setting";


function Index(e) {
  const { token } = useContext(AuthContext);
  const [user, setUser] = React.useState({});
  const { theme, changeTheme } = useContext(ThemeContext);
  const [event, setEvent] = useState({});
  const [inbox, setInbox] = React.useState({});
  const [isReminder, setIsReminder] = useState(false);
  const [input, setInput] = useState({});
  const [isPageLoader, setPageLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModal, setModal] = useState(false);
  const [meeting, setMeeting] = useState({});
  const [value, onChange] = useState(new Date());
  const [data, setData] = React.useState({});
  const { page } = React.useContext(settingContext);
  const history = useHistory();

  React.useEffect((e) => {
    window.scrollTo(0, 0);
  }, []);

  const handleInputs = (label, e) => {
    var val = e.target.value;
    setInput({ ...input, [label]: val });
  };

  React.useEffect(() => {
    checkUser();
    // dashboardGet();
  }, []);

  const checkUser = async () => {
    let userData = await _retrieveData('user_info')
    if (!userData) {
      history.push("/auth/login");
    }
    else {
      setUser(userData);
    }
  }

  React.useEffect((e) => {
    dashboardGet();
    eventsGet();
    getInbox();
  }, []);

  const eventsGet = async () => {
    setPageLoader(true);
    const { data_r, isError } = await authGetRequest(`/account/events`);
    if (isError) {
      errorMessage(toast, data_r?.message);
      setPageLoader(false);
      return false;
    }
    setEvent(data_r);
    setPageLoader(false);
  };

  const getInbox = async () => {
    let resp = await authGetRequest(`/account/inbox`);
    setInbox(resp.data_r);
  };

  const addReminder = async (e) => {
    setLoading(true);
    const { data_r, isError } = await authPostRequest(`/account/events`, input);
    if (isError) {
      errorMessage(toast, data_r?.message);
      setLoading(false);
      return false;
    }
    // await eventFilter(data_r.event);
    setEvent(data_r);
    successMessage(toast, "Successful");
    setIsReminder(false)
    setLoading(false);
  };

  const deleteReminder = async (e) => {
    setLoading(true);
    const { data_r, isError } = await authGetRequest(`/account/delete-reminder/${e}`);
    await eventsGet();
    setLoading(false);
  }

  const openMeetingLink = (meeting) => {
    setMeeting(meeting);
    setModal(true);
  };

  const dashboardGet = async () => {
    setPageLoader(true);
    const { data_r, isError } = await authGetRequest(`/account/dashboard`);
    if (isError) {
      // errorMessage(toast, data_r?.message);
      setPageLoader(false);
      return false;
    }
    setData(data_r);
    setPageLoader(false);
  };


  return (
    <div id="page-top" class="home">
      <div id="page-wrap">
        <MenuBar event={event} inbox={inbox} menuIndex="auth" setting={page?.setting} loader={isPageLoader} />
        <section className="profile-feature">
          <div className="awe-parallax bg-profile-feature" style={{ backgroundImage: 'url(../img/bg.jpg)' }} />
          <div className="awe-overlay overlay-color-3" />
          <div className="container">
            <div className="info-author">
              <div className="image">
                <img src={user?.image ? process.env.REACT_APP_LOCAL_FILE_PATH + "profile/medium/" + user.image : user?.gender === "male" ? '/static/media/male.png' : '/static/media/female.png'} alt="" />
              </div>
              <div className="name-author">
                <h2 className="big">{user?.first_name} {user?.last_name}</h2>
              </div>
              <div className="address-author">
                <i className="fa fa-map-marker" />
                <h3>{user?.country}</h3>
              </div>
            </div>
            <div className="info-follow">
              <div className="trophies">
                <span>{data?.cert_count}</span>
                <p>Certificates</p>
              </div>
              <div className="trophies">
                <span>{data?.count_course}</span>
                <p>Courses</p>
              </div>
              <div className="trophies">
                <span>{data?.count_active_course}</span>
                <p>Active Course</p>
              </div>
              <div className="trophies">
                <span>{data?.complete_course}</span>
                <p>Completed Course</p>
              </div>
            </div>
          </div>
        </section>

        <section className="content-bar">
          <div className="container">
            <ul style={{ width: '100%' }}>
              <li >
                <Link to="/student/home">
                  <i className="icon mdi mdi-book-open" />
                  Learning
                </Link>
              </li>
              <li>
                <Link to="/student/courses">
                  <i className="icon mdi mdi-note" />
                  Courses
                </Link>
              </li>
              <li className="current">
                <Link to="/student/calendar">
                  <i className="icon mdi mdi-calendar" />
                  Events
                </Link>
              </li>
              {/* <li>
                <a href="account-assignment.html">
                  <i className="icon mdi mdi-note" />
                  Assignment
                </a>
              </li> */}
              <li>
                <Link to="/student/profile">
                  <i className="icon mdi mdi-account" />
                  Profile
                </Link>
              </li>
              <li>
                <Link to="/student/inbox">
                  <i className="icon mdi mdi-gmail" />
                  Inbox
                </Link>
              </li>
            </ul>
          </div>
        </section>
        <section className="course-concern">
          <div className="container">
            <div className={theme === "light" ? "l_b content-wrapper" : "d_s_b content-wrapper"}>
              <div className="row">
                <div className="col-md-8 grid-margin stretch-card">
                  <div className="row w-100">
                    <div className="col-md-12">
                      <div className={theme === "light" ? "card" : "card d_s_b l_t"}>
                        <div className="card-body">
                          <HeaderText text="UPCOMING EVENT" />
                          <div className={`col-lg-12 col-md-12 col-sm-12 grid-margin stretch-card ${event?.event?.length == 0 ? 'h-20' : ''}`}>
                            {event?.event?.length == 0 && <h4 className="black">No Event</h4>}
                            <div className="table-wrap">
                             
                              <div className="table-head">
                                <div className="submissions" />
                              
                                <div className="tb-icon" />
                              </div>
                             
                              <div className="table-body">

                              
                                {event?.event?.map((item, index) => (
                                  <div onClick={() => openMeetingLink(item?.meeting)} className="table-item new">
                                    <div className="thead">
                                      <div className="submissions"><a href="#">{item.meeting?.title}</a></div>
                                      <div className="total-subm">{moment(item.meeting?.start_date).format("LL")}</div>
                                    
                                    </div>
                                    <div className="tbody ps-container" style={{ display: 'none' }}>
                                      <div className="ps-scrollbar-x-rail" style={{ width: '438px', display: 'none', left: '0px' }}><div className="ps-scrollbar-x" style={{ left: '0px', width: '0px' }} /></div><div className="ps-scrollbar-y-rail" style={{ top: '0px', height: '192px', display: 'none', right: '0px' }}><div className="ps-scrollbar-y" style={{ top: '0px', height: '0px' }} /></div></div>
                                  </div>
                                ))}
                               
                              </div>
                             
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-md-12">
                        <div className={theme === "light" ? "card" : "card d_s_b l_t"}>
                          <div className="card-body">
                            <HeaderText text="REMINDER" />
                            <div className={`col-lg-12 col-md-12 col-sm-12 grid-margin stretch-card ${event?.reminder?.length == 0 ? 'h-20' : ''}`}>
                              {event?.reminder?.length == 0 && <h4 className="black">No Reminder</h4>}
                              <div className="table-wrap">
                               
                                <div className="table-head">
                                  <div className="submissions" />
                                 
                                  <div className="tb-icon" />
                                </div>
                               
                                <div className="table-body">

                                
                                  {event?.reminder?.map((item, index) => (
                                    <div onClick={() => openMeetingLink(item)} className="table-item new">
                                      <div className="thead">
                                        <div className="submissions"><a href="#">{item?.name}</a></div>
                                        <div className="total-subm">{moment(item.start_date).format("LL")}</div>
                                        <div className="replied">{moment(item?.start_time, "HH:mm:ss").format("hh:mm A")}</div>
                                        <div className="latest-reply">{moment(item?.end_date).format("LL")}</div>
                                        <div className="toggle tb-icon">
                                          <a href="#"><i className="fa fa-angle-down" /></a>
                                        </div>
                                      </div>
                                      <div className="tbody ps-container" style={{ display: 'none' }}>
                                        <div className="ps-scrollbar-x-rail" style={{ width: '438px', display: 'none', left: '0px' }}><div className="ps-scrollbar-x" style={{ left: '0px', width: '0px' }} /></div><div className="ps-scrollbar-y-rail" style={{ top: '0px', height: '192px', display: 'none', right: '0px' }}><div className="ps-scrollbar-y" style={{ top: '0px', height: '0px' }} /></div></div>
                                    </div>
                                  ))}
                                 
                                </div>
                                
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-4 grid-margin stretch-card">
                 
                  <div className={""}>
                    <div className="card-body">
                      <HeaderText text="ADD REMINDER" />
                      <div className="new-course px-4">
                        <form action="" method="POST" enctype="multipart/form">
                          <div className="form-group mb-3">
                            <label
                              className="black "
                              for="basic-default-fullname"
                            >
                              Name <em>*</em>
                            </label>
                            <input
                              type="text"
                              onChange={(e) => handleInputs("name", e)}
                              className="form-control black"
                              name="name"
                              id="basic-default-fullname"
                              placeholder="e.g Time to learn"
                            />
                          </div>
                          <div className="form-group mb-3">
                            <label
                              className="black"
                              for="basic-default-fullname"
                            >
                              Choose Course
                            </label>
                            <select
                              name="course_id"
                              onChange={(e) => handleInputs("course_id", e)}
                              className="form-control black"
                            >
                              <option value="">Choose Course</option>
                              {event?.course?.map((item, index) => (
                                <option key={index} value={item.course.id}>
                                  {item.course.title}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="form-group mb-3">
                            <label
                              className="black"
                              for="basic-default-fullname"
                            >
                              Frequency
                            </label>
                            <select
                              name="is_required"
                              onChange={(e) => handleInputs("frequency", e)}
                              className="form-control black"
                            >
                              <option value="once">Once</option>
                              <option value="daily">Daily</option>
                              <option value="weekly">Weekly</option>
                              <option value="monthly">Monthly</option>
                            </select>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  className="black "
                                  for="basic-default-fullname"
                                >
                                  Start Date
                                </label>
                                <input
                                  type="date"
                                  className="form-control black"
                                  onChange={(e) => handleInputs("start_date", e)}
                                  name="start_date"
                                  id="basic-default-fullname"
                                  placeholder="0"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  className="black"
                                  for="basic-default-fullname"
                                >
                                  Start Time
                                </label>
                                <input
                                  type="time"
                                  className="form-control black"
                                  onChange={(e) => handleInputs("start_time", e)}
                                  name="start_time"
                                  id="basic-default-fullname"
                                  placeholder="0"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  className="black "
                                  for="basic-default-fullname"
                                >
                                  End Date
                                </label>
                                <input
                                  type="date"
                                  className="form-control black"
                                  onChange={(e) => handleInputs("end_date", e)}
                                  name="end_date"
                                  id="basic-default-fullname"
                                  placeholder="0"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3">
                                <label
                                  className="black"
                                  for="basic-default-fullname"
                                >
                                  End Time
                                </label>
                                <input
                                  type="time"
                                  className="form-control black"
                                  onChange={(e) => handleInputs("end_time", e)}
                                  name="end_time"
                                  id="basic-default-fullname"
                                  placeholder="0"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="mb-3">
                            <button
                              disabled={loading}
                              onClick={addReminder}
                              type="submit"
                              className="btn btn-success"
                            >
                              {!loading && `Add Reminder`}
                              {loading && (
                                <div className={Style.progressContainer}>
                                  <CircularProgress
                                    size={15}
                                    sx={{ color: "white", marginRight: 2 }}
                                  />
                                  <p>Connecting</p>
                                </div>
                              )}
                            </button>
                           
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <ModalLayout
            modal={isModal}
            backgroundColor={theme === "light" ? "background.paper" : "#212121"}
            content={
              <EventInfo meeting={meeting} setModal={setModal} />
            }
          />
        </section>
        <Footer setting={page?.setting} />
      </div>
    </div>
  );
};

export default Index;
